import { chargeConstants } from '../../_constants';
import { chargeService } from '../../_services';
import { alertActions, confirmPromptActions, userActions, } from '../index';

export const chargeActions = {
    getAllCharges,
    getChargeById,
    updateCharge,
    createCharge,
    deleteCharge,
    searchCharges,
    activation,
    getFullCharges,
    createChargeMulti,
    GetChargeForCreateCharge,
    getGlAccountIdFromBase,
    getStrippingStuffingSelection,
    getMasterCharge,
};

function chargeFetching() { return { type: chargeConstants.CHARGE_FETCHING } }
function chargeFetched() { return { type: chargeConstants.CHARGE_FETCHED } }

function getMasterCharge() {
    return dispatch => {
        dispatch(chargeFetching());
        chargeService.getMasterCharge()
            .then(
                masterCharge => {
                    dispatch(success(masterCharge));
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(masterCharge) { return { type: chargeConstants.GET_MASTER_CHARGE, masterCharge } }
}

function activation(id, isActive) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.notallowLeavePage());
        chargeService.activation(id, isActive)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(chargeFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(getChargeById(id));
                    dispatch(alertActions.success(isActive ? 'Charge activated successfully' : 'Charge deactivated successfully'))
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function searchCharges(skip, take, search, filter) {
    return dispatch => {
        chargeService.searchCharge(skip, take, search, filter)
            .then(
                charges => {
                    if (charges.length > 0) {
                        dispatch(searchCharge(charges))
                    } else {
                        dispatch(alertActions.error(charges.message));
                    }
                },
                error => {
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function searchCharge(charges) { return { type: chargeConstants.SEARCH_CHARGE, charges } }
}

function getAllCharges(skip, take, search, filter) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.allowLeavePage());
        chargeService.getAllCharges(skip, take, search, filter)
            .then(
                charges => {
                    if (charges.length > 0) {
                        dispatch(success(charges));
                        dispatch(chargeFetched());
                    } else {
                        dispatch(chargeFetched());
                        dispatch(alertActions.warning(charges.message))
                    }
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(charges) { return { type: chargeConstants.GET_CHARGES, charges } }
}

function getChargeById(code) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.allowLeavePage());
        chargeService.getChargeById(code)
            .then(
                charge => {
                    dispatch(success(charge))
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );

    };
    function success(charge) { return { type: chargeConstants.GET_CHARGE_BY_ID, charge } }
}

function updateCharge(Charge, userProfile) {
    return dispatch => {
        dispatch(updatingCharge());
        dispatch(userActions.notallowLeavePage());
        chargeService.updateCharge(Charge, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(updatedCharge());
                    dispatch(alertActions.success('Charge updated successfully'));
                    window.location.href = '/master_data/charges';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(updatedCharge());          
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function updatingCharge() { return { type: chargeConstants.UPDATE_CHARGE } }
    function updatedCharge() { return { type: chargeConstants.UPDATED_CHARGE } }
}
function createCharge(Charge, userProfile) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.notallowLeavePage());
        chargeService.createCharge(Charge, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(alertActions.success('Charge added successfully'));
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function createChargeMulti(Charge, serviceMatrix, userProfile) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.notallowLeavePage());
        chargeService.createChargeMulti(Charge, serviceMatrix, userProfile)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(chargeFetched());
                    dispatch(alertActions.success('Charge added successfully'));
                    window.location.href = '/master_data/charges';
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
}

function deleteCharge(id, type, take) {
    return dispatch => {
        dispatch(chargeFetching());
        dispatch(userActions.notallowLeavePage());
        chargeService.deleteCharge(id)
            .then(
                success => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(chargeFetched());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.success('charge deleted successfully'));
                    switch (type) {
                        case "specific":
                            window.location.href = '/master_data/charges';
                            break;
                        default:
                            dispatch(getAllCharges(0, take));
                            break;
                    }
                },
                error => {
                    dispatch(userActions.allowLeavePage());
                    dispatch(confirmPromptActions.hide());
                    dispatch(alertActions.error(error.toString()))
                    dispatch(getAllCharges(0, take));
                    dispatch(chargeFetched());
                }
            );
    };
}

function getFullCharges(category) {
    return dispatch => {
        chargeService.getFullCharges(category)
            .then(
                charges => dispatch(success(charges)),
                error => {
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(charges) { return { type: chargeConstants.GET_FULL_CHARGES, charges } }
}
function GetChargeForCreateCharge() {
    return dispatch => {
        dispatch(chargeFetching());
        chargeService.GetChargeForCreateCharge()
            .then(
                forCreateCharge => {
                    dispatch(success(forCreateCharge));
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(forCreateCharge) { return { type: chargeConstants.GET_CHARGE_FOR_CREATE_CHARGE, forCreateCharge } }
}

function getGlAccountIdFromBase(payload) {
    return dispatch => {
        dispatch(chargeFetching());
        chargeService.getGlAccountIdFromBase(payload)
            .then(
                GLData => {
                    dispatch(success(GLData));
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(GLData) { return { type: chargeConstants.GET_GL, GLData } }
}

function getStrippingStuffingSelection(payload) {
    return dispatch => {
        dispatch(chargeFetching());
        chargeService.getStrippingStuffingSelection(payload)
            .then(
                StfStrSelection => {
                    dispatch(success(StfStrSelection));
                    dispatch(chargeFetched());
                },
                error => {
                    dispatch(chargeFetched());
                    dispatch(alertActions.error(error.toString()))
                }
            );
    };
    function success(StfStrSelection) { return { type: chargeConstants.GET_STRIPPING_STUFFING_SELECTION, StfStrSelection } }
}